import Reveal from '../components/Reveal';
import { useLanguage } from '../context/LanguageContext';

function MarketingPage() {
  const { t } = useLanguage();
  const partnershipImages = [
    'https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1800&q=80',
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5gaAGz3qteeIxMGsuChnyoVPGf2dQWDitBA&s',
    'https://images.unsplash.com/photo-1574288061782-da2d3f79a72e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDZ8fGJhbmt8ZW58MHx8MHx8fDA%3D',
  ];

  return (
    <main className="inner-page">
      <section className="container marketing-page-hero-wrap">
        <Reveal>
          <h1 className="home-marketing-section-title">{t.marketingPage.sectionTitle}</h1>
        </Reveal>
        <div className="marketing-hero">
          <Reveal direction="left">
            <div className="marketing-hero-copy">
              <h2>{t.marketingPage.title}</h2>
              <ul className="marketing-hero-points">
                {t.marketingPage.points.map((point) => (
                  <li key={point.label}>
                    <strong>{point.label}</strong>
                    <span>{point.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal direction="right">
            <div className="marketing-hero-shot">
              <img
                src={`${process.env.PUBLIC_URL}/images/marketstartegy.jfif`}
                alt={t.marketingPage.title}
              />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="section marketing-methods-section">
        <div className="container">
          <Reveal>
            <h2 className="center-title marketing-methods-title">{t.marketingPage.methods}</h2>
            <h3 className="center-title marketing-methods-subtitle">{t.marketingPage.methodsSub}</h3>
          </Reveal>
          <div className="marketing-zigzag-list">
            {t.marketingPage.items.map((item, i) => {
              const isReverse = i % 2 === 1;
              return (
                <article
                  key={item.title}
                  className={`marketing-zigzag-row${isReverse ? ' marketing-zigzag-row-reverse' : ''}`}
                >
                  <Reveal direction={isReverse ? 'right' : 'left'}>
                    <div className="marketing-zigzag-media">
                      {item.video ? (
                        <video
                          className="marketing-zigzag-video"
                          src={item.video}
                          controls
                          playsInline
                          preload="metadata"
                        />
                      ) : (
                        <div className="marketing-zigzag-icon-panel">
                          <span className="material-symbols-outlined">{item.icon}</span>
                        </div>
                      )}
                    </div>
                  </Reveal>
                  <Reveal direction={isReverse ? 'left' : 'right'}>
                    <div className="marketing-zigzag-content">
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                    </div>
                  </Reveal>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section partnerships-section">
        <div className="container">
          <Reveal>
            <div className="services-head">
              <span className="eyebrow center">{t.marketingPage.partnerships.eyebrow}</span>
              <h2>{t.marketingPage.partnerships.title}</h2>
              <p>{t.marketingPage.partnerships.subtitle}</p>
            </div>
          </Reveal>
          <div className="cards">
            {t.marketingPage.partnerships.items.map((item, i) => (
              <Reveal key={item.title} delay={i * 120}>
                <article
                  className="card partnership-card partnership-card-image"
                  style={{
                    backgroundImage: `linear-gradient(180deg, rgba(10, 14, 28, 0.4), rgba(10, 14, 28, 0.78)), url(${partnershipImages[i % partnershipImages.length]})`,
                  }}
                >
                  <span className="material-symbols-outlined marketing-icon">{item.icon}</span>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default MarketingPage;
